import { render, staticRenderFns } from "./submitteAppraisal.vue?vue&type=template&id=5cfa6368&scoped=true&"
import script from "./submitteAppraisal.vue?vue&type=script&lang=js&"
export * from "./submitteAppraisal.vue?vue&type=script&lang=js&"
import style0 from "./submitteAppraisal.vue?vue&type=style&index=0&id=5cfa6368&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfa6368",
  null
  
)

export default component.exports